export type Voice = "human" | "agent" | "system";

export type Cue =
  | "message"
  | "mention"
  | "agentDone"
  | "agentNeedsYou"
  | "ringing"
  | "youJoined"
  | "somebodyJoined"
  | "somebodyLeft"
  | "callEnded"
  | "recordingStarted"
  | "sendFailed"
  | "summary";

export const CUES: readonly Cue[] = [
  "message",
  "mention",
  "agentDone",
  "agentNeedsYou",
  "ringing",
  "youJoined",
  "somebodyJoined",
  "somebodyLeft",
  "callEnded",
  "recordingStarted",
  "sendFailed",
  "summary",
];

const A_CALL_MAKES = new Set<Cue>([
  "ringing",
  "youJoined",
  "somebodyJoined",
  "somebodyLeft",
  "callEnded",
  "recordingStarted",
]);

export const isCallCue = (cue: Cue): boolean => A_CALL_MAKES.has(cue);

const ABOUT_YOU = new Set<Cue>(["mention", "agentNeedsYou", "sendFailed"]);

export const isPersonal = (cue: Cue): boolean => ABOUT_YOU.has(cue);

const ABOUT_WORDS = new Set<Cue>(["message", "mention", "agentDone", "agentNeedsYou", "summary"]);

export const isAboutWords = (cue: Cue): boolean => ABOUT_WORDS.has(cue);

const BURSTS = new Set<Cue>(["message", "mention"]);

export const bursts = (cue: Cue): boolean => BURSTS.has(cue);

export function voiceFor(cue: Cue, by: Voice | null): Voice {
  if (cue === "recordingStarted" || cue === "sendFailed") return "system";
  if (cue === "agentDone" || cue === "agentNeedsYou") return "agent";
  return by ?? "human";
}
